import { render, staticRenderFns } from "./ownerCommitteeManageList.vue?vue&type=template&id=25e239c2&scoped=true"
import script from "./ownerCommitteeManageList.vue?vue&type=script&lang=js"
export * from "./ownerCommitteeManageList.vue?vue&type=script&lang=js"
import style0 from "./ownerCommitteeManageList.vue?vue&type=style&index=0&id=25e239c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e239c2",
  null
  
)

export default component.exports